import { ajax } from "discourse/lib/ajax";
import RestModel from "discourse/models/rest";

export default class TopicLocalization extends RestModel {
  static fetch(topicId, locale) {
    return ajax(`/topic_localizations/${topicId}/${locale}`);
  }

  static createOrUpdate(topicId, locale, title) {
    return ajax("/topic_localizations/create_or_update", {
      type: "POST",
      data: {
        topic_id: topicId,
        locale,
        title,
      },
    });
  }

  static updateLocale(topicId, locale) {
    return ajax(`/topic_localizations/${topicId}/locale`, {
      type: "PUT",
      data: { locale: locale ?? "" },
    });
  }

  static destroy(topicId, locale) {
    return ajax("/topic_localizations/destroy", {
      type: "DELETE",
      data: {
        topic_id: topicId,
        locale,
      },
    });
  }
}
